import dartsTransformer from './darts';

const transformers = {
  darts: dartsTransformer
};

export { transformers };
